export default {
  // Header
  "title": "Generador Aleatorio de Pokémon",
  "subtitle": "Genera Pokémon aleatorios según tus preferencias",
  "home": "Inicio",
  "whichPokemonAmI": "¿Qué Pokémon Soy?",
  "aboutUs": "Sobre Nosotros",
  "contactUs": "Contáctanos",
  "privacyPolicy": "Política de Privacidad",
  
  // Filters
  "filterTitle": "Opciones de Filtro",
  "generateButton": "Generar Pokémon Aleatorio",
  "generating": "Generando...",
  "numberOfPokemon": "Número de Pokémon",
  "type": "Tipo",
  "generation": "Generación",
  "minimumRarity": "Rareza Mínima (1-10)",
  "anyType": "Cualquier Tipo",
  "anyGeneration": "Cualquier Generación",
  "anyRarity": "Cualquier Rareza",
  "countingPokemon": "Contando Pokémon coincidentes",
  "matchingPokemonCount": "{{count}} Pokémon coinciden con tus filtros",
  
  // Pokemon Types
  "normal": "Normal",
  "fire": "Fuego",
  "water": "Agua",
  "electric": "Eléctrico",
  "grass": "Planta",
  "ice": "Hielo",
  "fighting": "Lucha",
  "poison": "Veneno",
  "ground": "Tierra",
  "flying": "Volador",
  "psychic": "Psíquico",
  "bug": "Bicho",
  "rock": "Roca",
  "ghost": "Fantasma",
  "dragon": "Dragón",
  "dark": "Siniestro",
  "steel": "Acero",
  "fairy": "Hada",
  
  // Generations
  "Generation I": "Generación I",
  "Generation II": "Generación II",
  "Generation III": "Generación III",
  "Generation IV": "Generación IV",
  "Generation V": "Generación V",
  "Generation VI": "Generación VI",
  "Generation VII": "Generación VII",
  "Generation VIII": "Generación VIII",
  "Generation IX": "Generación IX",
  
  // Evolution Stage
  "evolutionStage": "Etapa Evolutiva",
  "evolutionStageAll": "Todas las Etapas",
  "evolutionStageFullyEvolved": "Totalmente Evolucionado",
  "evolutionStageNotFullyEvolved": "No Evolucionado del Todo",
  
  // About Section
  "aboutTitle": "Acerca del Generador Aleatorio de Pokémon",
  
  // Section titles
  "introTitle": "Bienvenido a Nuestro Generador Aleatorio de Pokémon",
  "howToUseTitle": "Cómo Usar el Generador Aleatorio de Pokémon",
  "benefitsTitle": "Beneficios de Usar Nuestro Generador Aleatorio de Pokémon",
  "historyTitle": "Historia de Pokémon",
  "popularPokemonTitle": "Pokémon Populares",
  "popularGamesTitle": "Juegos Populares de Pokémon",
  "tradingContestsTitle": "Intercambio y Concursos de Pokémon",
  "faqTitle": "Preguntas Frecuentes",
  "conclusionTitle": "¡Comienza Tu Aventura Aleatoria Pokémon Hoy!",
  
  // Footer
  "copyright": "© 2025 randompokemon.games",
  "trademark": "Pokémon y los nombres de los personajes de Pokémon son marcas registradas de Nintendo.",
  "linksTitle": "Enlaces Útiles",
  
  // About Us Page
  "aboutUsTitle": "Sobre Nosotros",
  "aboutUsWhoWeAre": "Quiénes Somos",
  "aboutUsWhoWeAreContent1": "Bienvenido al Generador Aleatorio de Pokémon, una herramienta creada por entusiastas apasionados de Pokémon. Nuestro viaje comenzó en 2023 cuando un grupo de desarrolladores que amaban tanto la programación como Pokémon decidieron crear una herramienta útil para la comunidad.",
  "aboutUsWhoWeAreContent2": "Nuestro equipo está formado por desarrolladores, diseñadores y creadores de contenido que trabajan juntos para proporcionar la mejor experiencia posible para los fanáticos de Pokémon en todo el mundo.",
  "aboutUsOurMission": "Nuestra Misión",
  "aboutUsOurMissionContent1": "Nuestro objetivo es hacer que el mundo de Pokémon sea más accesible y agradable para todos. Nuestras herramientas están diseñadas para ayudar a los entrenadores a descubrir nuevos Pokémon, crear equipos equilibrados y encontrar su Pokémon perfecto.",
  "aboutUsOurMissionContent2": "Estamos comprometidos a proporcionar una experiencia fácil de usar, precisa y divertida que respete la franquicia Pokémon mientras agregamos valor a la comunidad.",
  "aboutUsOurTeam": "Nuestro Equipo",
  "aboutUsOurTeamContent1": "Nuestro diverso equipo reúne experiencia en desarrollo web, conocimiento de Pokémon, diseño de experiencia de usuario y gestión comunitaria. Estamos unidos por nuestro amor por Pokémon y nuestro compromiso de crear herramientas de alta calidad.",
  "aboutUsOurTeamContent2": "Cada miembro del equipo contribuye con sus habilidades y perspectivas únicas para hacer del Generador Aleatorio de Pokémon lo mejor posible.",
  "aboutUsJoinUs": "Únete a Nosotros",
  "aboutUsJoinUsContent": "Siempre estamos buscando personas apasionadas para unirse a nuestra comunidad. Ya seas un desarrollador, diseñador, experto en Pokémon o usuario entusiasta, tu retroalimentación y contribuciones son bienvenidas.",

  // Contact Us Page
  "contactUsTitle": "Contáctanos",
  "contactUsGetInTouch": "Ponte en Contacto",
  "contactUsGetInTouchContent": "¿Tienes preguntas, sugerencias o comentarios sobre el Generador Aleatorio de Pokémon? ¡Nos encantaría saber de ti! Aquí tienes cómo puedes comunicarte con nuestro equipo.",
  "contactUsEmail": "Correo Electrónico",
  "contactUsPhone": "Teléfono",
  "contactUsAddress": "Dirección",
  "contactUsHelpSupport": "Ayuda y Soporte",
  "contactUsHelpSupportContent": "¿Necesitas ayuda para usar nuestras herramientas o has encontrado un problema? Nuestro equipo de soporte está aquí para ayudarte.",
  "contactUsFAQ": "Preguntas Frecuentes",
  "contactUsFAQContent": "Antes de contactarnos, consulta nuestra sección de Preguntas Frecuentes que cubre muchas preguntas y problemas comunes.",
  "contactUsBugReport": "Informar un Error",
  "contactUsBugReportContent": "Si has encontrado un error o problema técnico, háznos saber enviando un correo electrónico con 'INFORME DE ERROR' en el asunto.",

  // Privacy Policy Page
  "privacyPolicyTitle": "Política de Privacidad",
  "privacyPolicyIntro": "Introducción",
  "privacyPolicyIntroContent": "En el Generador Aleatorio de Pokémon, respetamos tu privacidad y estamos comprometidos a proteger tus datos personales. Esta Política de Privacidad explica cómo recopilamos, usamos y protegemos tu información cuando usas nuestro sitio web.",
  "privacyPolicyInformation": "Información que Recopilamos",
  "privacyPolicyInformationContent": "Recopilamos información mínima para proporcionar y mejorar nuestros servicios. Esto puede incluir:",
  "privacyPolicyInformationItem1": "Datos de uso (como páginas visitadas, tiempo en el sitio y funciones utilizadas)",
  "privacyPolicyInformationItem2": "Información del dispositivo (tipo de navegador, sistema operativo y resolución de pantalla)",
  "privacyPolicyInformationItem3": "Dirección IP y ubicación aproximada (solo a nivel de país)",
  "privacyPolicyCookies": "Cookies y Tecnologías Similares",
  "privacyPolicyCookiesContent": "Utilizamos cookies para mejorar tu experiencia en nuestro sitio web. Estos pequeños archivos de texto nos permiten recordar tus preferencias y analizar cómo se utiliza nuestro sitio. Puedes controlar las cookies a través de la configuración de tu navegador.",
  "privacyPolicyThirdParty": "Servicios de Terceros",
  "privacyPolicyThirdPartyContent": "Nuestro sitio web puede utilizar servicios de terceros como proveedores de análisis y redes de entrega de contenido. Estos servicios pueden recopilar información sobre tu uso de nuestro sitio web. Nos aseguramos de que todos los terceros respeten tu privacidad y manejen los datos de manera adecuada.",
  "privacyPolicySecurity": "Seguridad de Datos",
  "privacyPolicySecurityContent": "Implementamos medidas de seguridad apropiadas para proteger tu información contra acceso, alteración o divulgación no autorizados. Sin embargo, ninguna transmisión por Internet es 100% segura, por lo que no podemos garantizar una seguridad absoluta.",
  "privacyPolicyChanges": "Cambios en esta Política",
  "privacyPolicyChangesContent": "Podemos actualizar nuestra Política de Privacidad de vez en cuando. Te notificaremos sobre cualquier cambio publicando la nueva Política de Privacidad en esta página y actualizando la fecha de 'última actualización'.",
  "privacyPolicyContact": "Contáctanos",
  "privacyPolicyContactContent": "Si tienes alguna pregunta sobre esta Política de Privacidad, contáctanos a través de la información proporcionada en nuestra página de Contacto.",
  "privacyPolicyLastUpdated": "Última Actualización",
  
  // Which Pokemon Am I Page
  "whichPokemonAmITitle": "¿Qué Pokémon Soy?",
  "whichPokemonAmISubtitle": "Descubre qué Pokémon se adapta mejor a ti",
  "enterYourName": "Ingresa tu nombre",
  "namePlaceholder": "Tu nombre",
  "enterFavoriteColor": "Elige tu color favorito",
  "enterBirthMonth": "Elige tu mes de nacimiento",
  "selectBirthMonth": "Seleccionar mes",
  "enterPersonalityTrait": "Elige un rasgo de personalidad",
  "selectPersonalityTrait": "Seleccionar rasgo",
  "findMyPokemon": "Encontrar mi Pokémon",
  "calculating": "Calculando...",
  "yourPokemonIs": "Tu Pokémon es",
  "pokemonDescription": "Descripción",
  "personalityMatch": "Coincidencia de personalidad",
  "yourCompatibility": "Tu compatibilidad",
  "downloadImage": "Descargar imagen",
  "shareResult": "Compartir resultado",
  "tryAgain": "Intentar de nuevo",
  "results": "Resultados",
  "aboutTool": "Sobre esta herramienta",
  "howToUse": "Cómo usar",
  "benefits": "Beneficios",
  "faq": "FAQ",
  "conclusion": "Conclusión",
  
  // Error messages
  "nameRequired": "El nombre es obligatorio",
  "colorRequired": "Por favor elige un color",
  "monthRequired": "Por favor elige un mes",
  "traitRequired": "Por favor elige un rasgo de personalidad",
  
  // Months
  "january": "Enero",
  "february": "Febrero",
  "march": "Marzo",
  "april": "Abril",
  "may": "Mayo",
  "june": "Junio",
  "july": "Julio",
  "august": "Agosto",
  "september": "Septiembre",
  "october": "Octubre",
  "november": "Noviembre",
  "december": "Diciembre",
  
  // Personality Traits
  "brave": "Valiente",
  "calm": "Tranquilo",
  "timid": "Tímido",
  "jolly": "Alegre",
  "quiet": "Callado",
  "hasty": "Apresurado",
  "careful": "Cuidadoso",
  "lonely": "Solitario",
  "bold": "Audaz",
  "relaxed": "Relajado",
  "impish": "Travieso",
  "modest": "Modesto",
  
  // Size matching feature
  "enterHeightWeight": "Ingresa tu altura y peso — ¡descubre qué Pokémon coincide contigo!",
  "whichPokemonMatchesSize": "¿Qué Pokémon coincide con tu tamaño?",
  "youAreMostLike": "Te pareces más a",
  
  // Additional translations for size matching feature
  "heightValid": "Por favor ingresa una altura válida (1-300 cm)",
  "weightValid": "Por favor ingresa un peso válido (1-500 kg)",
  "enterDetails": "Ingresa tus datos",
  "nameLabel": "Nombre",
  "heightLabel": "Altura",
  "weightLabel": "Peso",
  "finding": "Buscando...",
  "errorFinding": "Error al buscar tu Pokémon",
  "matchResult": "El Pokémon de {{name}} es...",
  "similarityScore": "Puntuación de Similitud",
  "downloadStarted": "Preparando tu imagen...",
  "downloadComplete": "¡Imagen descargada con éxito!",
  "shareText": "¡Descubrí que soy {{pokemon}}! ¡Encuentra tu Pokémon también!",

  "madeBy": "Hecho por",

  // New Page: Pokemon Randomizer - About Section Titles (Translated to Spanish)
  "pokemonRandomizerPageAboutTitle": "Explora la Experiencia Definitiva del Randomizador de Pokémon",
  "pokemonRandomizer_whatIsItTitle": "¿Qué es Exactamente un Randomizador de Pokémon?",
  "pokemonRandomizer_featuresTitle": "Características Clave de Nuestra Herramienta Randomizador de Pokémon",
  "pokemonRandomizer_whyUseTitle": "¿Por Qué Embarcarse en una Aventura con un Randomizador de Pokémon?",
  "pokemonRandomizer_gettingStartedTitle": "Primeros Pasos: Tu Primera Partida con el Randomizador de Pokémon",
  "pokemonRandomizer_faqTitle": "Randomizador de Pokémon: Preguntas Frecuentes",

  // New keys for PokemonRandomizerPage.tsx H1 and subtitle (Translated to Spanish)
  "pokemonRandomizerPageH1": "Randomizador de Pokémon",
  "pokemonRandomizerPageSubtitle": "Crea experiencias Pokémon únicas con nuestra herramienta randomizadora avanzada.",

  // Sub-Footer
  subFooterToolsTitle: "Herramientas",
  subFooterRandomPokemonGeneratorLink: "Generador Aleatorio de Pokémon",
  subFooterPokemonRandomizerLink: "Randomizador de Pokémon",
  subFooterWhichPokemonAmILink: "¿Qué Pokémon Soy?",

  subFooterPokemonDatabaseTitle: "Base de Datos Pokémon",
  subFooterPokedexLink: "Pokédex (Próximamente)",
  subFooterTypeChartsLink: "Tablas de Tipos (Próximamente)",
  subFooterMoveListLink: "Lista de Movimientos (Próximamente)",

  subFooterBlogTitle: "Blog",
  subFooterLatestArticlesLink: "Últimos Artículos (Próximamente)",
  subFooterGuidesTutorialsLink: "Guías y Tutoriales (Próximamente)"
};
